module.exports = __webpack_public_path__ + "email_icon_32x32.0cb4fb533b8051c6bbef.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/assets/images/email_icon_32x32.png
// module id = ../../../../../src/assets/images/email_icon_32x32.png
// module chunks = styles